module.exports = __webpack_public_path__ + "static/media/galerija_2013 (6).8590f520.jpg";